import { sortedClips } from './timeline.js';
/**
 * **Wohin der Abspielkopf nach dem Löschen geht** (Sascha, 15. Oktober:
 * „Beim löschen sollte der Abspieler auch um die gelöschte Länge nach vorne
 * rutschen. Momentan bleibt er stehen und ist an einer ganz anderen Stelle
 * wenn man was löscht“ -- und: „Beim löschen: zurückfallen auf den Clip
 * links. Ans Ende :)“).
 *
 * - Stand der Kopf **auf** dem Gelöschten, fällt er auf den Clip links davon
 *   zurück, an dessen Ende (ein Bild davor, damit er noch auf ihm steht und
 *   man sein letztes Bild sieht). Gibt es links keinen, steht er dort, wo
 *   der gelöschte Clip anfing.
 * - Stand er **woanders**, bleibt er bei dem, was er gezeigt hat: rückt der
 *   Clip unter ihm nach vorn (Magnet, Nachrücken), rückt der Kopf mit.
 * - Gewählt ist danach der Clip links -- so lässt sich weiter nach hinten
 *   löschen, ohne neu zu tippen.
 *
 * Gerechnet aus dem Stand davor und danach: was der Magnet oder das
 * Nachrücken bewegt hat, steckt schon im Danach.
 */
export function nachLoeschen(vorher, nachher, geloescht, kopf, fps) {
    const weg = new Set(geloescht);
    const basis = vorher.tracks.find((t) => t.kind === 'video');
    const alle = vorher.tracks.flatMap((t) => t.clips.map((c) => ({ c, spur: t.id })));
    const geloeschte = alle.filter((x) => weg.has(x.c.id));
    const ende = nachherEnde(nachher);
    if (geloeschte.length === 0)
        return { kopf: Math.min(kopf, ende), wahl: null };
    // Der früheste gelöschte Clip -- bei Gleichstand der auf der Hauptspur.
    geloeschte.sort((a, b) => a.c.start - b.c.start || (a.spur === basis?.id ? -1 : b.spur === basis?.id ? 1 : 0));
    const erster = geloeschte[0];
    const spur = vorher.tracks.find((t) => t.id === erster.spur);
    const links = sortedClips(spur)
        .filter((c) => !weg.has(c.id) && c.start < erster.c.start - 1e-9)
        .at(-1);
    const linksNachher = links ? finde(nachher, links.id) : undefined;
    const darauf = geloeschte.some(({ c }) => kopf >= c.start - 1e-9 && kopf < c.start + c.duration - 1e-9);
    if (darauf) {
        if (linksNachher) {
            const bild = 1 / fps;
            const ziel = Math.max(linksNachher.start, linksNachher.start + linksNachher.duration - bild);
            return { kopf: klemme(ziel, ende), wahl: linksNachher.id };
        }
        return { kopf: klemme(erster.c.start, ende), wahl: null };
    }
    // Woanders: dem Clip unter dem Kopf folgen, zuerst auf der Hauptspur.
    const spuren = [...vorher.tracks].sort((a, b) => (a.id === basis?.id ? -1 : b.id === basis?.id ? 1 : 0));
    for (const t of spuren) {
        const unter = t.clips.find((c) => !weg.has(c.id) && kopf >= c.start - 1e-9 && kopf < c.start + c.duration - 1e-9);
        const danach = unter ? finde(nachher, unter.id) : undefined;
        if (unter && danach)
            return { kopf: klemme(kopf + (danach.start - unter.start), ende), wahl: linksNachher?.id ?? null };
    }
    return { kopf: klemme(kopf, ende), wahl: linksNachher?.id ?? null };
}
function finde(t, id) {
    for (const spur of t.tracks)
        for (const c of spur.clips)
            if (c.id === id)
                return c;
    return undefined;
}
function nachherEnde(t) {
    let ende = 0;
    for (const spur of t.tracks)
        for (const c of spur.clips)
            ende = Math.max(ende, c.start + c.duration);
    return ende;
}
function klemme(x, ende) {
    return Math.round(Math.max(0, Math.min(ende, x)) * 1e6) / 1e6;
}
//# sourceMappingURL=loeschen.js.map